import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getPaginationPayload } from '~/utils/pagination';
import { IThunkGetNotes, INotesStore } from '../types';

const onGetNotes: IThunkGetNotes = thunk(
  // @ts-ignore
  async ({ setNotes, reset }, filters, { getState }) => {
    reset();

    const localState = getState() as INotesStore;

    const paginationPayload = getPaginationPayload(localState.pagination);

    const { data } = await api.notes.getList({
      ...filters,
      ...paginationPayload,
    });

    setNotes(data);
  },
);

export default onGetNotes;
